import React, { useState } from 'react';
import Papa from 'papaparse'; // Library for CSV parsing
import QRCode from 'qrcode.react'; // QR code generation library

import './App.css';

function App() {
  const [csvData, setCsvData] = useState([]);
  const [printing, setPrinting] = useState(false);
  const [showImage, setShowImage] = useState(false);
  const [showQr, setShowQr] = useState(true);
  const [fontSize, setFontSize] = useState('x-small');
  const [filter, setFilter] = useState('');
  const [filterHeader, setFilterHeader] = useState('id');
  const [filterGreaterThan, setFilterGreaterThan] = useState();

  const chosenHeaderList = ['time_observed_at', 'description', 'latitude', 'longitude', 'scientific_name', 'common_name'];

  const loadCsv = (file) => {
    console.log({ file })
    Papa.parse(file, {
      complete: (result) => {
        setCsvData(result.data);
      },
      header: true,
      error: (error) => {
        console.error('there was an error', error);
      }
    });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    loadCsv(file);
  };

  const handlePrint = () => {
    setPrinting(true);
    window.print();
    setPrinting(false);
  };

  const handleRestart = () => {
    setCsvData([]);
    setShowImage(true);
  };

  const handleFontSizeChange = (event) => {
    setFontSize(event.target.value);
  };

  const generateCell = (key, value) => {
    if (!chosenHeaderList.includes(key)) {
      return <></>;
    }
    return (
      <div key={key} className="csv-cell">
        <span className="header">{key}:</span> {value}
      </div>
    );
  }

  const extractMycoDexNumber = (inputString) => {
    const regex = /Sequence Number:\*\* #(\d+)/;
    const match = inputString.match(regex);
    return match ? match[1] : undefined;
  }

  const extractNiobraraId = (inputString) => {
    const regex = /\b\d{2}-\d{4}(\.\d)?\b/;  // Matches 'nn-nnnn' or 'nn-nnnn.n'
    const match = inputString.match(regex);
    return match ? match[0] : undefined;
  };
  

  const extractIdFromDescription = (inputString) => {
    // console.log({inputString});
    const match = inputString.match(/\b(\d{3})\b/);
    return match ? match[1] : extractMycoDexNumber(inputString) || extractNiobraraId(inputString);
  }

  const generateId = (record) => {
    const descriptionId = extractIdFromDescription(record['description'] ?? '');
    const fieldId = record['field:project collection id'];
    console.log({ descriptionId }, { fieldId });
    if (!!!descriptionId && !!!fieldId) {
      return null;
    }
    return fieldId === '' ? descriptionId : fieldId;
  }

  const generateIdElement = (record) => {
    const id = generateId(record);
    if (!id) {
      return <></>;
    }
    return (
      <>
        <div className="csv-cell">
          <span className="header">project collection id:</span> <h2 style={{display: 'inline'}}>{id}</h2>
        </div>
        <div className="csv-cell">
          <span className="header">inat id:</span> {record['id']}
        </div>
      </>
    );
  }

  const generateInatLink = (record) => {
    const url = record['url'];
    return (
      <div className="csv-cell">
        <span className="header">inat_url</span> <a href={url} target='_blank' rel='noreferrer'>{url}</a>
      </div>
    );
  }

  const handleFilterHeaderChange = (event) => {
    setFilterHeader(event.target.value);
  };

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filterRows = (row) => {
    const id = generateId(row) ?? -1;
    if (filterGreaterThan) {
      console.log(id > filterGreaterThan, [row], [id], [filterGreaterThan])
      return id > filterGreaterThan
    }
    if (filter && filterHeader === 'id') {
      return filter.split(',').map((id) => id.trim()).includes(id);
    }
    if (filter && filterHeader) {
      const filterList = filter.split(',').map((url) => url.trim());
      return filterList.includes(row[filterHeader]);
    }

    return true; // show all rows
  };

  const handleFilterGreaterThanChange = (e) => {
    const value = parseInt(e.target.value, 10);
    setFilterGreaterThan(isNaN(value) ? 0 : value);
  };

  return (
    <div className="App">
      <header className="App-header">
        <div className='no-print'>
          <h1 className='title'>Record Printer 🧬</h1>
          <label className='control'>
            <input
              type="checkbox"
              checked={showImage}
              onChange={() => setShowImage(!showImage)}
            />
            Display main image on sheet?
          </label>
          <label className='control'>
            <input
              type="checkbox"
              checked={showQr}
              onChange={() => setShowQr(!showQr)}
            />
            Display iNat QR Code?
          </label>
          <label className='control'>
            Font Size:
            <select value={fontSize} onChange={handleFontSizeChange}>
              <option value="xx-small">XX-Small</option>
              <option value="x-small">X-Small</option>
              <option value="small">Small</option>
              <option value="medium">Medium</option>
              <option value="large">Large</option>
            </select>
          </label>
          <input className='control' type="file" onChange={handleFileChange} accept=".csv" />
          {csvData.length > 0 && (
            <>
              <button className='control' onClick={handlePrint} disabled={printing}>
                Print
              </button>
              <button className='control' onClick={handleRestart}>Restart</button>
              <label className='control'>
                Filter Header:
                <input
                  type="text"
                  value={filterHeader}
                  onChange={handleFilterHeaderChange}
                />
              </label>
              <label className='control'>
                Filter List (comma-separated):
                <input
                  type="text"
                  value={filter}
                  onChange={handleFilterChange}
                />
              </label>
              <label>
                Filter ID Greater Than
                <input
                  value={filterGreaterThan}
                  onChange={handleFilterGreaterThanChange}
                />
              </label>
              <hr />
            </>
          )}
        </div>
        {csvData.length > 0 && (
          <>
            <p>Total Entries: {csvData.length}</p>
            <p>Narrowed Search: {csvData.filter(filterRows).length}</p>
            <p className='no-print'>The following data will be printed.</p><p className='no-print'>Index cards 3X5, headers on, and portrait mode is recommended.</p>
            <div className="csv-rows" style={{ fontSize: `${fontSize}` }}>
              {csvData.filter(filterRows).map((record, index) => (
                <div key={index} className="csv-row">
                  {showImage && <img className='main-image' src={record['main_image_url']} alt={record['inat_id']} />}
                  {showQr && <QRCode className='qr-code' value={record['url']} />}
                  {generateIdElement(record)}
                  {Object.entries(record)
                    .map(([key, value]) => generateCell(key, value))
                  }
                  {generateInatLink(record)}
                </div>
              ))}
            </div>
          </>
        )}
      </header>
    </div>
  );
}

export default App;
